import React from "react";
import Image from "./Image";
import { SvgImages } from "../../Utils/LocalImages";
import { object } from "yup";

function SubmitButton({ title,reducewidth,navbarloginbtn,hoverTitle, ...props }) {
  return (
    <button className="submit-button d-flex align-items-end" {...props}>     
      <div className={`submitButtonBackground ${reducewidth} ${navbarloginbtn}  d-flex align-items-center`}title={hoverTitle}  >
        <h2
          className="white Sub-Heading fw-600 mb-0 w-100 singleLine text-center"
          style={{ lineHeight: "unset" }}
        >
          {title}
        </h2>
      </div>
      <div className="button-submit-cutout"></div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="43"
        className="buttonEndPattern"
        height="42"
        viewBox="0 0 43 42"
        fill="none"
      >
        <path
          d="M16 26C15.2 14 5 3.66667 0 0H43.5L43 42C35 31.5 21.5 27 16 26Z"
          fill="#F6821F"
        ></path>
      </svg>

    </button>
  );
}

export default SubmitButton;
